import { ExpManifestDrmInfo } from '@nativewaves/exp-core'
import { ContentSource } from '@nativewaves/nw-cloud-sdk/content'

export const getEnvType = () => {
  const envType = import.meta.env.VITE_NW_ENVIRONMENT_INSTANCE
  switch (envType) {
    case 'production':
      return 'prod'
    case 'testing':
      return 'test'
    case 'development':
    default:
      return 'dev'
  }
}

type GetDrmCredentialsFnProps = ContentSource | undefined

export const getDrmCredentialsFn = (data: GetDrmCredentialsFnProps) => {
  return async (drmInfo: ExpManifestDrmInfo[]) => {
    if (!drmInfo?.length || !data) {
      return
    }

    const licenseId = data.drmKeys?.find((key) => drmInfo[0].drmProviderId === key.drmProviderId)?.licenseId
    const drmCredentials = data.drmLicenseInfos?.find((info) => info.id === licenseId)?.data
    if (!drmCredentials) {
      return
    }
    return drmCredentials
  }
}
